<template>
  <div>
    <ChartBox :title="title" style="position: relative">
      <div class="container">
        <!-- 内容区域 -->
        <div class="content-wrapper">
          <div class="scoreboard-container">
            <div class="days-display">
              <span class="days-label">{{ sub_title }}</span>
              <div
                  v-for="(digit, index) in digitArray"
                  :key="index"
                  class="digit"
                >
                  {{ digit }}
                </div>
              <span class="days-label">天</span>
            </div>
          </div>
          <div
            style="
              color: #999;
              font-size: 14px;
              text-align: right;
              margin-right: 40px;
              margin-top: 20px;
            "
          >
            {{ from_date }}
          </div>
          <div
            style="
              color: white;
              font-size: 17px;
              text-align: right;
              margin-right: 40px;
              margin-top: 40px;
            "
          >
            {{ user }}
          </div>
        </div>

        <!-- 背景图片 -->
        <img
          :src="safe_logo"
          class="background-image"
        />
      </div>
    </ChartBox>
  </div>
</template>

<script>
import ChartBox from "../components/chartBox.vue";
import { baseImgUrl } from "../utils/request";
// 引入混入
import { myMixin } from "../common/common.js";

export default {
  data() {
    return {};
  },
  // props: {
  //   days: {
  //     type: Number,
  //     default: 150,
  //   },
  // },
  computed: {
    digitArray() {
      // 将数字转换为字符串，然后拆分成单个数字
      return this.days.toString().split("");
    },
  },
  mixins: [myMixin],
  components: {
    ChartBox,
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  width: 100%;
  height: 100%;
}

.content-wrapper {
  position: relative;
  z-index: 10; /* 确保内容在图片上方 */
}

.background-image {
  position: absolute;
  width: 99%;
  opacity: 0.4;
  top: -30px;
  height: 100%;
  z-index: 1; /* 图片层级低于内容 */
  left: 0;
}
.scoreboard-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 10px;
  margin-top: 30px;
}

.days-display {
  display: flex;
  align-items: center;
  font-size: 26px;
  font-weight: bold;
  color: white;
}

.days-label {
  // margin: 0 5px;
  // color: #333;
}

// .scoreboard {
//   display: flex;
//   background: linear-gradient(145deg, #2c3e50, #34495e);
//   border-radius: 8px;
//   padding: 8px 12px;
//   box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
//   border: 2px solid #1a252f;
// }
.scoreboard {
  position: relative;
  display: flex;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 10px;
  padding: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 0 30px rgba(0, 255, 255, 0.2);
}

.digit {
  width: 34px;
  height: 60px;
  background-size: 400% 400%;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 2px;
  border-radius: 6px;
  font-size: 30px;
  font-weight: bold;
  text-shadow: 0 0 8px rgba(0, 0, 0, 0.8);
  box-shadow: inset 0 2px 4px rgba(255, 255, 255, 0.3),
    inset 0 -2px 4px rgba(0, 0, 0, 0.5), 0 4px 8px rgba(0, 0, 0, 0.3);
  animation: hologram 3s ease-in-out infinite;
  border: 1px solid rgba(255, 255, 255, 0.2);
}
// .digit::before {
//   content: "";
//   position: absolute;
//   top: 0;
//   left: 0;
//   right: 0;
//   width: 5px;
//   height: 80px;
//   background: linear-gradient(
//     90deg,
//     transparent,
//     rgba(255, 255, 255, 0.05),
//     transparent
//   );
//   animation: scanHorizontal 2s linear infinite;
// }

@keyframes scanHorizontal {
  0% {
    left: -10px;
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    left: calc(100% + 10px);
    opacity: 0;
  }
}
</style>

